import { render, staticRenderFns } from "./EvanFooter.vue?vue&type=template&id=483dde7b"
import script from "./EvanFooter.vue?vue&type=script&lang=js"
export * from "./EvanFooter.vue?vue&type=script&lang=js"
import style0 from "./EvanFooter.vue?vue&type=style&index=0&id=483dde7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports